module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/jcb-663aba989c9ca1670dd2f3ae4c5db3b4.png";